/**
 * Shared infrastructure for the summarization-agent flag dismiss/restore
 * + row-glow feature. Consumed by the four flag-bearing agent panels.
 */

export { flagKey, type FlagAgentKind } from "./flagKey";
export {
  useFlagDismissals,
  type UseFlagDismissalsResult,
  type FlagDismissal,
  type FlagRef,
} from "./useFlagDismissals";
export { FlagDismissButton, FlagDismissEditor } from "./FlagDismissControl";

/**
 * Class applied to a flag badge/icon that represents an active
 * (non-dismissed) flag. Produces the pulsing red glow that draws the
 * practitioner's attention to the flag itself. Returns an empty string
 * when the flag is dismissed, so the glow clears on dismissal.
 */
export function flagGlowClass(active: boolean): string {
  return active ? "animate-flag-glow" : "";
}
